
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useActivityFeed } from "@/hooks/useActivityFeed";
import { Skeleton } from "@/components/ui/skeleton";
import { Users, Briefcase, Calendar, CheckCircle } from "lucide-react";
import { formatDistanceToNow } from "date-fns";

const activityIcons = {
  candidate: Users,
  job: Briefcase,
  interview: Calendar,
  placement: CheckCircle,
};

export const RecentActivity = () => {
  const { data: activities, isLoading } = useActivityFeed();

  if (isLoading) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>Recent Activity</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            {[...Array(5)].map((_, i) => (
              <div key={i} className="flex items-start space-x-3">
                <Skeleton className="h-4 w-4 mt-1" />
                <div className="flex-1 space-y-1">
                  <Skeleton className="h-4 w-3/4" />
                  <Skeleton className="h-3 w-1/2" />
                </div>
                <Skeleton className="h-3 w-16" />
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    );
  }

  if (!activities || activities.length === 0) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>Recent Activity</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-center py-6 text-muted-foreground">
            <p>No recent activity</p>
            <p className="text-sm">Start by adding candidates or creating job postings</p>
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Recent Activity</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {activities.map((activity) => {
            const IconComponent = activityIcons[activity.type];
            return (
              <div key={activity.id} className="flex items-start space-x-3">
                <IconComponent className="h-4 w-4 mt-1 text-muted-foreground" />
                <div className="flex-1 space-y-1">
                  <p className="text-sm font-medium">{activity.title}</p>
                  <p className="text-xs text-muted-foreground">{activity.description}</p>
                </div>
                <span className="text-xs text-muted-foreground">
                  {formatDistanceToNow(new Date(activity.timestamp), { addSuffix: true })}
                </span>
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
};
